export default "__VITE_ASSET__B_qZYqkq__ 640w, __VITE_ASSET__dr6CiL7n__ 1024w, __VITE_ASSET__DXsP9be4__ 1536w";